// $(document).ready(function () {
//   $("#Metric-form, #Imperial-form").submit(function (event) {
//     event.preventDefault();
//     var formData = $(this).serializeArray();
//     var dataType = $(this).data("id");
//     var keyValueArray = [];
//     var feetValue = "";
//     var inchesValue = "";
//     var weightKg = "";
//     $.each(formData, function (index, field) {
//       if (
//         dataType === "imperial" &&
//         (field.name === "feet" || field.name === "inches")
//       ) {
//         if (field.name === "feet") {
//           feetValue = field.value;
//         } else if (field.name === "inches") {
//           inchesValue = field.value;
//         }
//         var heightValue = feetValue + "." + inchesValue;
//         if (field.name === "inches") {
//           var keyValue = { height: heightValue };
//           keyValueArray.push(keyValue);
//         }
//       } else {
//         var keyValue = {};
//         keyValue[field.name] = field.value;
//         keyValueArray.push(keyValue);
//       }
//       if (field.name === "weightlbs") {
//         var weightLbs = parseFloat($("[name='weightlbs']").val());
//         weightKg = weightLbs * 0.453592;
//         console.log(weightKg, "l00");
//       }
//     });
//     console.log(keyValueArray);
//     var heightIndexValues = [];
//     var weightIndexValues = [];
//     if ($(".youth_option").length == 1 && keyValueArray[2]["age"] <= 14) {
//       console.log(dataType);
//       if (dataType === "imperial") {
//         $("#metric-youth tr:gt(0) td:nth-child(2)").each(function (index) {
//           var value = $(this).text();
//           var splitValue = value.split("-");
//           heightIndexValues.push(splitValue);
//         });
//       } else {
//         $("#metric-youth tr:gt(0) td:first-child").each(function () {
//           var value = $(this).text();
//           var splitValue = value.split("-");
//           heightIndexValues.push(splitValue);
//         });
//       }
//       $("#metric-youth tr:first-child td").each(function (index) {
//         if (index != 0 && index != 1) {
//           var value = $(this).text();
//           var splitValue = value.split("-");
//           weightIndexValues.push(splitValue);
//         }
//       });
//     } else {
//       if (dataType === "imperial") {
//         $("#metric-table tr:gt(0) td:nth-child(2)").each(function () {
//           var value = $(this).text();
//           var splitValue = value.split("-");
//           heightIndexValues.push(splitValue);
//         });
//       } else {
//         $("#metric-table tr:gt(0) td:first-child").each(function (index) {          
//             var value = $(this).text();
//             var splitValue = value.split("-");
//             heightIndexValues.push(splitValue);
//         });
//       }
//       $("#metric-table tr:first-child td").each(function (index) {
//         if (index != 0 && index != 1) {
//           var value = $(this).text();
//           var splitValue = value.split("-");
//           weightIndexValues.push(splitValue);
//         }
//       });
//     }


//    console.log(heightIndexValues);
//     var heightindex = 1;
//     for (var i = 0; i < heightIndexValues.length; i++) {
//       var oki = i + 1;
//       var value = heightIndexValues[i];
//       if (value[0] <= Number(keyValueArray[0]["height"]) && value[1] > Number(keyValueArray[0]["height"])) {
//         heightindex = heightindex + i;
//         break;
//       }else if(heightIndexValues.length == oki && value[1] == Number(keyValueArray[0]["height"])){
//         heightindex = heightindex + i;
//         break;
//       }else{
//         if ((heightIndexValues.length - 1) == i) {
//           heightindex = undefined;
//         }
//       }
//     }
//     console.log(heightindex);
    

//     console.log(weightIndexValues);
//     var weightindex = 2;
//     for (var i = 0; i < weightIndexValues.length; i++) {
//       var value = weightIndexValues[i];
//       console.log(weightKg);
//       if (weightKg != "") {
//         if (value[0] <= weightKg && value[1] > weightKg) {
//           weightindex = weightindex + i;
//           break;
//         }else{
//           if ((weightIndexValues.length - 1) == i) {
//             weightindex = undefined;
//           }
//         }
//       } else {
//         if (value[0] <= parseInt(keyValueArray[1]["weight"]) && value[1] > parseInt(keyValueArray[1]["weight"])) {
//           weightindex = weightindex + i;
//           break;
//         } else {
//           if ((weightIndexValues.length - 1) == i) {
//             weightindex = undefined;
//           }
//         }
//       }
//     }
//     console.log(weightindex);

//     // Accessing the specific value from the table based on heightindex and weightindex
//     var specificValue = "";
//     if ($(".youth_option").length == 1 && keyValueArray[2]["age"] <= 14) {
//       specificValue = $("#metric-youth tr").eq(heightindex).find("td").eq(weightindex).text();
//     } else {
//       specificValue = $("#metric-table tr").eq(heightindex).find("td").eq(weightindex).text();
//     }

//     if(heightindex == undefined || weightindex ==  undefined || heightindex == '' || weightindex == ' '){
//       $("#fit-let").text(" : Unable to find your size" + specificValue);
//     }else{
//       $("#fit-let").text(" : " + specificValue);
//     }
//     console.log(specificValue);
//     $(".modal-table .slide-fit-form").hide();
//     $(".modal-table .slide-fit-size").show();
//   });

  
//   $("#form-button-reset").click(function () {
//     $("#Metric-form input:not([type='submit']").val("");
//     $("#Imperial-form input:not([type='submit']").val("");
//     $("#fit-let").text("");
//     $(".modal-table .slide-fit-form").show();
//     $(".modal-table .slide-fit-size").hide();
//   });
// });

$(document).ready(function () {

  function feetDotInchesToTotalInches(val) {
    var parts = String(val).split(".");
    var ft = parseInt(parts[0]) || 0;
    var inch = parseInt(parts[1]) || 0;
    return ft * 12 + inch;
  }

  $("#Metric-form, #Imperial-form").submit(function (event) {
    event.preventDefault();
    var formData = $(this).serializeArray();
    var dataType = $(this).data("id");
    var keyValueArray = [];
    var feetValue = "";
    var inchesValue = "";
    var weightKg = "";

    $.each(formData, function (index, field) {
      if (
        dataType === "imperial" &&
        (field.name === "feet" || field.name === "inches")
      ) {
        if (field.name === "feet") {
          feetValue = field.value;
        } else if (field.name === "inches") {
          inchesValue = field.value;
        }
        var heightValue = feetValue + "." + inchesValue;
        if (field.name === "inches") {
          var keyValue = { height: heightValue };
          keyValueArray.push(keyValue);
        }
      } else {
        var keyValue = {};
        keyValue[field.name] = field.value;
        keyValueArray.push(keyValue);
      }
      if (field.name === "weightlbs") {
        var weightLbs = parseFloat($("[name='weightlbs']").val());
        weightKg = weightLbs * 0.453592;
        console.log(weightKg, "l00");
      }
    });

    console.log(keyValueArray);

    var heightIndexValues = [];
    var weightIndexValues = [];

    if ($(".youth_option").length == 1 && keyValueArray[2]["age"] <= 14) {
      if (dataType === "imperial") {
        $("#metric-youth tr:gt(0) td:nth-child(2)").each(function (index) {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      } else {
        $("#metric-youth tr:gt(0) td:first-child").each(function () {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      }
      $("#metric-youth tr:first-child td").each(function (index) {
        if (index != 0 && index != 1) {
          var value = $(this).text();
          var splitValue = value.split("-");
          weightIndexValues.push(splitValue);
        }
      });
    } else {
      if (dataType === "imperial") {
        $("#metric-table tr:gt(0) td:nth-child(2)").each(function () {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      } else {
        $("#metric-table tr:gt(0) td:first-child").each(function (index) {
          var value = $(this).text();
          var splitValue = value.split("-");
          heightIndexValues.push(splitValue);
        });
      }
      $("#metric-table tr:first-child td").each(function (index) {
        if (index != 0 && index != 1) {
          var value = $(this).text();
          var splitValue = value.split("-");
          weightIndexValues.push(splitValue);
        }
      });
    }

    console.log(heightIndexValues);

    var heightindex = 1;

    if (dataType === "imperial") {
      var inputTotalInches = feetDotInchesToTotalInches(keyValueArray[0]["height"]);
      for (var i = 0; i < heightIndexValues.length; i++) {
        var oki = i + 1;
        var rangeLow  = feetDotInchesToTotalInches(heightIndexValues[i][0]);
        var rangeHigh = feetDotInchesToTotalInches(heightIndexValues[i][1]);
        if (rangeLow <= inputTotalInches && rangeHigh > inputTotalInches) {
          heightindex = heightindex + i;
          break;
        } else if (heightIndexValues.length == oki && rangeHigh == inputTotalInches) {
          heightindex = heightindex + i;
          break;
        } else {
          if ((heightIndexValues.length - 1) == i) {
            heightindex = undefined;
          }
        }
      }
    } else {
      for (var i = 0; i < heightIndexValues.length; i++) {
        var oki = i + 1;
        var value = heightIndexValues[i];
        if (value[0] <= Number(keyValueArray[0]["height"]) && value[1] > Number(keyValueArray[0]["height"])) {
          heightindex = heightindex + i;
          break;
        } else if (heightIndexValues.length == oki && value[1] == Number(keyValueArray[0]["height"])) {
          heightindex = heightindex + i;
          break;
        } else {
          if ((heightIndexValues.length - 1) == i) {
            heightindex = undefined;
          }
        }
      }
    }

    console.log(heightindex);

    console.log(weightIndexValues);

    var weightindex = 2;
    for (var i = 0; i < weightIndexValues.length; i++) {
      var value = weightIndexValues[i];
      console.log(weightKg);
      if (weightKg != "") {
        if (value[0] <= weightKg && value[1] > weightKg) {
          weightindex = weightindex + i;
          break;
        } else {
          if ((weightIndexValues.length - 1) == i) {
            weightindex = undefined;
          }
        }
      } else {
        if (value[0] <= parseInt(keyValueArray[1]["weight"]) && value[1] > parseInt(keyValueArray[1]["weight"])) {
          weightindex = weightindex + i;
          break;
        } else {
          if ((weightIndexValues.length - 1) == i) {
            weightindex = undefined;
          }
        }
      }
    }

    console.log(weightindex);

    var specificValue = "";
    if ($(".youth_option").length == 1 && keyValueArray[2]["age"] <= 14) {
      specificValue = $("#metric-youth tr").eq(heightindex).find("td").eq(weightindex).text();
    } else {
      specificValue = $("#metric-table tr").eq(heightindex).find("td").eq(weightindex).text();
    }

    if (heightindex == undefined || weightindex == undefined || heightindex == '' || weightindex == '') {
      $("#fit-let").text(" : Unable to find your size");
    } else {
      $("#fit-let").text(" : " + specificValue);
    }

    console.log(specificValue);
    $(".modal-table .slide-fit-form").hide();
    $(".modal-table .slide-fit-size").show();
  });

  $("#form-button-reset").click(function () {
    $("#Metric-form input:not([type='submit'])").val("");
    $("#Imperial-form input:not([type='submit'])").val("");
    $("#fit-let").text("");
    $(".modal-table .slide-fit-form").show();
    $(".modal-table .slide-fit-size").hide();
  });

});